import { GenIcon } from '../helpers/IconBase.es.js';

const CircleBankColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "rect",
        attr: { width: "24", height: "24", rx: "12", fill: "#F0FAFF" }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.30371 17.217H8.86851V10.4346H7.30371V17.217Z",
          fill: "#5877A6"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.9126 17.217H11.478V10.4346H9.9126V17.217Z",
          fill: "#5877A6"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5215 17.217H14.0863V10.4346H12.5215V17.217Z",
          fill: "#5877A6"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.1299 17.217H16.6953V10.4346H15.1299V17.217Z",
          fill: "#5877A6"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.30371 11.9993H8.86851V11.2169H7.30371V11.9993Z",
          fill: "#43618B"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.9126 11.9993H11.478V11.2169H9.9126V11.9993Z",
          fill: "#43618B"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5215 11.9993H14.0863V11.2169H12.5215V11.9993Z",
          fill: "#43618B"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.1299 11.9993H16.6953V11.2169H15.1299V11.9993Z",
          fill: "#43618B"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M11.8746 6.0312L6.1362 9.162C6.0516 9.2076 6 9.2952 6 9.3906V10.956C6 11.1006 6.1164 11.217 6.2604 11.217H17.739C17.883 11.217 18 11.1006 18 10.956V9.3906C18 9.2952 17.9472 9.2076 17.8638 9.162L12.1248 6.0312C12.0858 6.0102 12.0426 6 12 6C11.9568 6 11.9136 6.0102 11.8746 6.0312Z",
          fill: "#C9DEF2"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10.9561 8.86921C10.9561 9.44521 11.4235 9.91321 12.0001 9.91321C12.5761 9.91321 13.0429 9.44521 13.0429 8.86921C13.0429 8.29321 12.5761 7.82581 12.0001 7.82581C11.4235 7.82581 10.9561 8.29321 10.9561 8.86921Z",
          fill: "white"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.2604 16.4346C6.1164 16.4346 6 16.551 6 16.6956V17.217C6 17.361 6.1164 17.478 6.2604 17.478H17.739C17.883 17.478 18 17.361 18 17.217V16.6956C18 16.551 17.883 16.4346 17.739 16.4346H6.2604Z",
          fill: "#C9DEF2"
        }
      }
    ]
  })(props);
};

export { CircleBankColored };
